import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'categoriesFilterLabel',
})
export class CategoriesFilterLabelPipe implements PipeTransform {
  transform(categories: string[]): string {
    if (!categories || categories.length === 0) {
      return 'All';
    }

    if (categories.length === 1) {
      return categories[0];
    }

    if (categories.length > 1) {
      return `${categories[0]} +${categories.length - 1} more`;
    }

    return 'All';
  }
}
